import { inject, Injectable } from "@angular/core";
import {
  doc,
  Firestore, updateDoc,
} from "@angular/fire/firestore";
import { ObjectHelper } from "../helpers/object.helper";
import { WebShipmentModel } from "../models/web-shipment.model";

@Injectable({
  providedIn: 'root',
})
export class WebShipmentService {

  private firestore = inject(Firestore);

  /**
   * Update an order
   * @param id The id of the order to update
   * @param partialOrder The fields of the order to update
   * @returns The promise
   */
  public update(id: string, partialOrder: Partial<WebShipmentModel>): Promise<void> {
    const ref = doc(this.firestore, 'web-shipments', id)
      .withConverter(WebShipmentModel.converter);
    return updateDoc(ref, ObjectHelper.anonymize(partialOrder));
  }
}
